module.exports = __webpack_public_path__ + "img/pic_ChanghuaCity.2233165e.jpg";